import React from "react";
import classes from "./classes.module.scss";
import ToastElement from "./ToastElement";
import classNames from "classnames";
import { Toasts, IToast } from "@Front/Stores/Toasts";

type IProps = Record<string, never>;
type IState = {
	toastList: IToast[];
};
export class ToastsContainerClass extends React.Component<IProps, IState> {
	private removeOnChange?: () => void;

	public constructor(props: IProps) {
		super(props);
		this.state = {
			toastList: Toasts.getInstance().toasts,
		};

		this.updateToasts = this.updateToasts.bind(this);
	}

	public override render(): React.JSX.Element {
		return (
			<div className={classNames(classes["root"], this.state.toastList.length > 0 && classes["open"])}>
				{this.state.toastList.map((toast) => (
					<ToastElement toast={toast} key={toast.id} />
				))}
			</div>
		);
	}

	public override componentDidMount(): void {
		this.removeOnChange = Toasts.getInstance().onChange(this.updateToasts);
	}

	public override componentWillUnmount(): void {
		this.removeOnChange?.();
	}

	private updateToasts(toastList: IToast[]): void {
		this.setState({ toastList });
	}
}

export default function ToastsContainer(props: IProps): React.JSX.Element {
	return <ToastsContainerClass {...props} />;
}
